var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarFilterGrey = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.0156 4.36955C17.9194 4.14729 17.76 3.95822 17.5572 3.82584C17.3544 3.69347 17.1172 3.62363 16.875 3.62502H3.12498C2.88305 3.6255 2.64646 3.69617 2.44391 3.82846C2.24135 3.96076 2.08154 4.14899 1.98386 4.37032C1.88618 4.59165 1.85483 4.83658 1.8936 5.07538C1.93238 5.31418 2.03963 5.53659 2.20232 5.71565L2.20857 5.72268L7.49998 11.3727V17.375C7.49993 17.6013 7.56127 17.8233 7.67748 18.0174C7.79368 18.2115 7.96038 18.3704 8.15981 18.4772C8.35924 18.584 8.58392 18.6347 8.8099 18.6239C9.03587 18.613 9.25466 18.5411 9.44295 18.4156L11.9429 16.7485C12.1143 16.6343 12.2548 16.4796 12.352 16.298C12.4492 16.1165 12.5 15.9137 12.5 15.7078V11.3727L17.7922 5.72268L17.7984 5.71565C17.9628 5.53741 18.0711 5.3147 18.1097 5.07531C18.1484 4.83592 18.1156 4.59045 18.0156 4.36955ZM11.4203 10.7016C11.3122 10.8162 11.2513 10.9675 11.25 11.125V15.7078L8.74998 17.375V11.125C8.75003 10.9663 8.6897 10.8135 8.58123 10.6977L3.12498 4.87502H16.875L11.4203 10.7016Z",
  fill: "#49454E"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarFilterGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_filter_grey.c4a604567275ecaf99bfb3959c741166.svg";